import { useCallback } from 'react';
import axios from 'axios';

type FileInfo = {
  name: string;
  uri: string;
  extension?: string;
  forceDownload?: boolean;
};

export default function useDownloadFile() {
  const urlToBlob = async (reader, url): Promise<any> =>
    new Promise((resolve, reject) => {
      if (!url) resolve(null);

      axios
        .get(url, {
          responseType: 'blob',
          withCredentials: true,
        })
        .then(({ data }) => {
          reader.readAsDataURL(data);
          reader.onloadend = () => {
            resolve(reader.result);
          };
        })
        .catch(reject);
    });

  const createElementAndClick = (uri, name, extension) => {
    const elem = document.createElement('a');

    elem.href = uri || '';
    elem.download = name + (extension || '');
    elem.target = '_blank';
    elem.hidden = true;
    elem.click();
    elem.remove();
  };

  return useCallback(async (fileInfo: FileInfo) => {
    const reader = new FileReader();
    const { name, uri, extension } = fileInfo;

    if (fileInfo.forceDownload) {
      try {
        const blob = await urlToBlob(reader, uri);
        createElementAndClick(blob, name, extension);
      } catch (error) {
        throw new Error('Não foi possível fazer o download do arquivo');
      }
    } else {
      createElementAndClick(uri, name, extension);
    }
  }, []);
}
